<template>
    <div class="global_content" v-bind:class="this.dark ? 'dark' : ''">
        <div class="bacnground ">
            <div class="header-courses-row">
                <div class="title">
                    <p>Meus Cursos</p>
                </div>
                <div class="search-container">
                    <div class="search-input-wrapper">
                        <input
                            type="text"
                            v-model="search"
                            placeholder="Pesquisar curso..."
                            class="search-input"
                        />
                        <span class="search-icon">
                            <!-- SVG de lupa -->
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="9" cy="9" r="7" stroke="#888" stroke-width="2"/>
                                <line x1="14.2929" y1="14.7071" x2="18" y2="18.4142" stroke="#888" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
            <div class="courses" v-show="hasReady && user && user.type != null"> 
                <CourseCard
                    v-for="course in filteredCourses"
                    :key="course.course ? course.course.id : course.id"
                    :image="course.course && course.course.imageFinalPath2"
                    :progress="course.course && course.course.progressPercentage != null ? (course.course.progressPercentage) : 0"
                    :title="course.course && course.course.name"
                    :id="user && user.type == 3 ? course.id : (course.course ? course.course.id : course.id)"
                    :status="course.course && course.course.status"
                    :data="course"
                    :invertOrder="true"
                ></CourseCard>
                <div v-if="filteredCourses.length === 0 && hasReady && user && user.type != null" class="no-results">
                    Nenhum curso encontrado.
                </div>
            </div>
            <span class="loader home" v-show="!hasReady || !user || user.type == null"></span>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import CourseCard from './CourseCard.vue';
import { mapState } from 'vuex';


export default {
    data() {
        return {
            search: ''
        }
    },
    components: {
        CourseCard,
        Loader
    },
    computed: {
        ...mapState(['dark', 'user']),
        filteredCourses() {
            if (!this.data || !this.user || this.user.type == null) return [];
            if (!this.search) return this.data;
            const searchLower = this.search.toLowerCase();
            return this.data.filter(course => {
                const name = course.course && course.course.name ? course.course.name.toLowerCase() : '';
                return name.includes(searchLower);
            });
        }
    },
    props: {
        view: Boolean,
        data: Array,
        hasReady: Boolean
    },
}
</script>
<style>
.global_content {
    background-color: white;
    padding-top: 20px;
}
.global_content.dark {
    background-color: rgb(0, 0, 0);
}

.global_content .courses {
    display: flex;
    gap: 32px 20px;
    flex-wrap: wrap;
}
.global_content .course {
    height: 400px;
    flex: 1 1 calc(33.33% - 20px);
    background-repeat: no-repeat;
    position: relative;
    border-radius: 10px !important;
    cursor: pointer;
    background-size: cover;
    box-sizing: border-box;
    max-width: 33%;
} 

@media (max-width: 1024px) {
    .global_content .bacnground {
        padding: 30px 40px;
    }
    .global_content .course {
        flex: 1 1 calc(50% - 20px);
        max-width: 50%;
        height: 300px;
    }
}

@media (max-width: 768px) {
    .global_content .bacnground {
        padding: 20px 10px;
    }
    .global_content .course {
        flex: 1 1 100%;
        max-width: 100%;
        height: 400px; /* Mantém a altura igual ao desktop */
    }
    .global_content .header-courses-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .global_content .search-container {
        width: 100%!important;
        max-width: 100%!important;
        margin-top: 10px;
        justify-content: flex-start;
        display: flex;
    }
    .global_content .search-input-wrapper {
        width: 100%;
        max-width: 100%;
    }
}

@media (max-width: 480px) {
    .global_content .bacnground {
        padding: 20px!important;
    }
    .global_content .course {
        flex: 1 1 100%;
        max-width: 100%;
        height: 400px; /* Mantém a altura igual ao desktop */
    }
    .global_content .title p {
        font-size: 18px;
    }
    .global_content .search-input {
        font-size: 14px;
        padding: 8px 36px 8px 12px;
    }
    .global_content .no-results {
        font-size: 15px;
        margin-top: 24px;
    }
    .global_content .search-container {
        width: 100%;
        max-width: 100%;
        margin-top: 10px;
        justify-content: flex-start;
        display: flex;
    }
    .global_content .search-input-wrapper {
        width: 100%!important;
        max-width: 100%!important;
    }
}

.global_content .title{
    margin: 0;
}
.global_content .bacnground {
    max-width: 1600px!important;
    padding: 0px 10px!important;
    margin: 0px auto;
}
.global_content .title p {
    color: #242424;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 103.6%;
    letter-spacing: 0.24px;
}
.global_content .infos {
    position: absolute;
    width: 100%;
    bottom: 5%;
    text-align: left;
}
.global_content .progress_course {
    align-items: center;
    display: flex;
    padding: 0 10px;
    color: #b4b1ad;
    font-size: 12px;
}
.global_content .infos p {
    padding: 0 25px;
    overflow: hidden;
    color: #F3F3F3;
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    margin: 0;
}
.global_content .progress_course {
    display: flex;
}
.global_content.dark .title p {
    color: white;
}
.global_content .loader.home {
    z-index: 999999;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 48px;
    height: 48px;
    border: 5px solid #1AC7D0;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}
.global_content .header-courses-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 20px;
}

.global_content .search-container {
    margin: 0;
    display: flex;
    justify-content: flex-end;
    width: 50%;
    max-width: 50%;
}
.global_content .search-input-wrapper {
    position: relative;
    width: 65%;
    display: flex;
    align-items: center;
}
.global_content .search-input { 
    padding: 8px 40px 8px 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    width: 100%;
    outline: none;
    transition: border 0.2s;
    box-sizing: border-box;
}
.global_content .search-input:focus {
    border: 1.5px solid #1AC7D0;
}
.global_content .search-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;
}
.global_content .no-results {
    width: 100%;
    text-align: center;
    color: #888;
    font-size: 18px;
    margin-top: 40px;
}
.global_content .degrade {
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgb(16 16 16) 0%, rgba(0, 0, 0, 0.5858718487394958) 15%, rgba(0, 212, 255, 0) 83%);
    width: 100%;
    height: 335px!important;
    position: absolute;
    border-radius: 10px !important;
}
</style>